<template>
  <div class="column868" ref="column868">
    <slot />
    <div  v-if="footerTitle" class="accordion">
      <h2 class="accordion-title">
        <button v-html="$sanitize(footerTitle)"
          class="btn-accordion btn-collapse"
          aria-controls="accordion1"
          aria-expanded="false"
        ></button>
      </h2>
      <div
        id="accordion1"
        class="collapsed collapse-container"
        v-html="$sanitize(footerContent)"
      ></div>
    </div>
  </div>
  <div v-if="isLargeDesktop && sideBarContent">
    <div class="fixed-column fixed-column-covidsearch" ref="covidSearchSide" :style="`top: ${sideBarContentTop}; bottom: ${sideBarContentBottom};`">
      <div v-html="$sanitize(sideBarContent)" class="covid-search-side" />
    </div>
  </div>
</template>

<script>
import {
  inject, ref, onMounted, onUnmounted, nextTick,
} from 'vue';
import { ContentService } from '@/services';

export default {
  setup() {
    const isLessThanLargeDesktop = inject('isLessThanLargeDesktop');
    const isLargeDesktop = inject('isLargeDesktop');
    const content = ContentService.getSearchCentersPageContents();
    const footerTitle = content?.field_accordion_title && content.field_accordion_title[0]?.value;
    const footerContent = content?.field_accordion_text && content.field_accordion_text[0].value;
    const sideBarContent = content?.field_right_column_text
      && content?.field_right_column_text[0]?.value;
    const sideBarContentTop = ref('');
    const sideBarContentBottom = ref('');
    const column868 = ref('');
    const covidSearchSide = ref('');
    function updateColumnPosition() {
      const sideBarOverflow = window.pageYOffset + column868.value.offsetTop + covidSearchSide.value.offsetHeight;
      const sideBarTop = (window.pageYOffset - 30 >= 0) ? window.pageYOffset - 30 : 0;
      if (sideBarOverflow > column868.value.offsetHeight) {
        sideBarContentTop.value = 'auto';
        sideBarContentBottom.value = '0';
      } else {
        sideBarContentTop.value = `${sideBarTop}px`;
        sideBarContentBottom.value = 'auto';
      }
    }
    onMounted(async () => {
      await nextTick();
      updateColumnPosition();
      window.addEventListener('scroll', updateColumnPosition);
    });
    onUnmounted(() => {
      window.removeEventListener('scroll', updateColumnPosition);
    });
    return {
      footerTitle,
      sideBarContent,
      footerContent,
      isLessThanLargeDesktop,
      isLargeDesktop,
      sideBarContentTop,
      sideBarContentBottom,
      column868,
      covidSearchSide,
    };
  },
};
</script>
